import { default as statistics } from ":src/modules/analysis/statistics/routes";
import { default as help } from ":src/modules/help-center/routes";
import { default as profile } from ":src/modules/profile/routes";
export default {
  BASE: "/auditor",
  statistics,
  help,
  profile,
};
